export default "__VITE_ASSET__C$vu99HP__"